/* @flow */

import moment from 'moment';

export default class SetCompanyUserInfoRequest {
  isoCompanyId: number;
  companyId: number;
  companyPersonId: number;

  titleId: number;

  lastName: string;
  firstName: string;

  email: string;
  phone: string;
  mobile: string;

  addressLine1: string;
  addressLine2: string;
  zipCode: string;
  city: string;
  countryId: number;

  nationalityId: number;
  birthCountryId: number;
  birthDate: moment;
  birthPlace: string;

  functionName: string;

  languageId: number;

  registrationTypeId: number;
  registrationNumber: string;
  registrationExpireDate: moment;
}
